module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/package-deals-icon-87ef3b3341eca0a3aaf0f66f0de83747.png";